import styled from 'styled-components';

export const Button = styled.button`
    width: 100%;
    font-family: Khula;
    font-style: normal;
    font-weight: bold;
    font-size: 22px;
    line-height: 22px;
    text-align: center;
    color: #D6E1EF;
    outline: none;
    background: linear-gradient(90.25deg, #F06500 -21.19%, #FFA05C 126.2%);
    box-shadow: -5px -6px 16px rgba(195, 200, 205, 0.04), 6px 6px 28px rgba(0, 0, 0, 0.3);
    border-radius: 16px;
    border: none;
    height: 62px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    opacity: 0.95;
    @media only screen and (max-width: 768px) {
        font-size: 22px;
        line-height: 100%;
        text-align: center;
    }
`;